import { WorkflowListItem } from '@/app/workflows/components/v6/molecues/WorkflowListItem';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { memo, useState } from 'react';
import { Stack } from '@mantine/core';
import { TableUtilsProvider } from '@/app/workflows/components/table/contexts/TableUitlsContext';

interface WorkflowListProps {
  workflows: Workflow[];
  onRun: (workflow: Workflow) => void;
  onWorkflowAdded: () => void;
}

const useExpandedWorkflows = () => {
  const [expandedWorkflows, setExpandedWorkflows] = useState<number[]>([]);

  const toggle = (id: number) => {
    setExpandedWorkflows((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const isExpanded = (id: number) => expandedWorkflows.includes(id);

  const setExpandedValue = (id: number, value?: boolean) => {
    setExpandedWorkflows((prev) => {
      if (value === undefined) {
        return prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id];
      }

      return value ? [...prev, id] : prev.filter((i) => i !== id);
    });
  };

  return {
    expandedWorkflows,
    toggle,
    isExpanded,
    setExpandedValue,
  };
};

function WorkflowList({ workflows, onRun, onWorkflowAdded }: WorkflowListProps) {
  const { isExpanded, toggle, expandedWorkflows, setExpandedValue } = useExpandedWorkflows();

  const handledWorkflowAdded = () => {
    onWorkflowAdded();
  };

  return (
    <TableUtilsProvider
      tableObject={{
        expandedWorkflows,
        setExpandedValue,
        isExpanded,
        setPage: () => {},
        scrollToTop: () => {},
      }}
    >
      <Stack maw='100%' p='xs' gap='sm'>
        {workflows.map((workflow) => (
          <WorkflowListItem
            key={workflow.id}
            workflow={workflow}
            onRun={() => onRun(workflow)}
            onWorkflowAdded={handledWorkflowAdded}
            toggle={toggle}
            opened={isExpanded(workflow.id)}
          />
        ))}
      </Stack>
    </TableUtilsProvider>
  );
}

export default memo(WorkflowList);
